import sticky from './_sticky';

export function stickySidebar() {
  const spacingEl = document.querySelector('.sticky-margin');
  let spacing = 0;
  if(spacingEl) spacing = spacingEl.clientHeight

  const sidebar = document.querySelector('.sticky-sidebar');
  if(sidebar) {
    new sticky(sidebar, {
      topSpacing: spacing*1.5,
      bottomSpacing: spacing,
      containerSelector: '.sticky-container',
      minWidth: 1023
    });
  }

  const sidebarFilter = document.querySelector('.sticky-sidebar-filter');
  if(sidebarFilter) {
    new sticky(sidebarFilter, {
      topSpacing: spacing*1.5,
      bottomSpacing: spacing,
      containerSelector: '.sticky-container',
      minWidth: 1023
    });
  }

  const sidebarFriendsMap = document.querySelector('.sticky-sidebar-friends-map');
  if(sidebarFriendsMap) {
    new sticky(sidebarFriendsMap, {
      topSpacing: spacing*1.5,
      bottomSpacing: spacing,
      containerSelector: '.sticky-container-friends-map',
      minWidth: 1023
    });
  }
}